export * from './taxAssessor';
export * from './nycDetails';
export * from './lookupTable';
export * from './lotAddress';
export * from './lotData';
export * from './lotMap';
